import React from "react";

const ReturnAndExchangePolicy = () => {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full mx-auto text-gray-800">
      <h1 className="text-2xl font-bold mb-4">
        Brick and Bar – Return and Exchange Policy
      </h1>

      <p className="mb-4">
        At Brick and Bar, we value your satisfaction and strive to offer a
        seamless shopping experience. If you’re not completely satisfied with
        your purchase, we offer a flexible return and exchange policy to ensure
        your convenience and confidence in shopping with us.
      </p>

      <h2 className="text-xl font-semibold mb-3">
        Eligibility for Returns and Exchanges
      </h2>
      <ul className="list-disc ml-6 mb-4 space-y-1">
        <li>
          Items must be returned within <strong>7 days</strong> of delivery.
        </li>
        <li>
          Products should be unused, undamaged, and in their original packaging
          with all tags intact.
        </li>
        <li>
          Return/exchange is applicable only if the item is defective, damaged,
          or different from what was ordered.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mb-3">Non-returnable Items</h2>
      <ul className="list-disc ml-6 mb-4 space-y-1">
        <li>Customized or personalized products</li>
        <li>
          Items purchased during clearance sales or marked as "Final Sale"
        </li>
        <li>Used, worn, or washed items</li>
      </ul>

      <h2 className="text-xl font-semibold mb-3">Return & Exchange Process</h2>
      <ol className="list-decimal ml-6 mb-4 space-y-1">
        <li>
          Go to your order history and select the item you want to return or
          exchange.
        </li>
        <li>
          Fill out the return/exchange request form and mention the reason.
        </li>
        <li>
          Our team will verify the request and schedule a pickup, if applicable.
        </li>
        <li>
          Once we receive the product and verify its condition, the
          refund/exchange will be processed.
        </li>
      </ol>

      <h2 className="text-xl font-semibold mb-3">Refund Details</h2>
      <ul className="list-disc ml-6 mb-4 space-y-1">
        <li>
          Refunds will be processed within <strong>5–7 business days</strong>{" "}
          after receiving the returned product.
        </li>
        <li>The refund will be credited to the original mode of payment.</li>
        <li>
          Shipping charges (if any) are non-refundable unless the item is
          damaged or incorrect.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mb-3">Contact Us</h2>
      <p className="mb-4">
        If you have any questions or need assistance with returns or exchanges,
        feel free to reach out to our customer support team at{" "}
        <a
          href="mailto:support@brickandbar.com"
          className="text-blue-600 hover:underline"
        >
          support@brickandbar.com
        </a>
        .
      </p>

      <p className="italic text-sm text-gray-600">
        Note: Brick and Bar reserves the right to refuse returns that do not
        meet our return policy guidelines.
      </p>
    </div>
  );
};

export default ReturnAndExchangePolicy;
